import { AggregateUnitData } from 'features/overview'
import { SiteViewMapProps } from 'features/siteMap/SiteViewMap'
import isNil from 'lodash/isNil'
import React from 'react'
import { GeckoSite } from 'types'

import { UnitSelectionDisplay } from './featureTypeDisplays/UnitSelectionDisplay'
import { UnknownSelectionDisplay } from './featureTypeDisplays/UnknownSelectionDisplay'

/**
 * Gets the (React) component to render when a feature is clicked on the map.
 */
export function getComponentToDisplayOnFeatureClick(
  aggregateUnitData: ReadonlyArray<AggregateUnitData>,
  site: GeckoSite,
  isCalculatingRL: boolean,
  selectedYear: number,
  useAssetLifecycle: boolean
): SiteViewMapProps['componentToDisplayOnFeatureClick'] {
  return function componentToDisplayOnFeatureClick(unitID) {
    if (isNil(unitID)) {
      return <UnknownSelectionDisplay />
    }
    const unitData = aggregateUnitData.find(
      (unit) => unit.unitSpecs.unitData.id === unitID
    )

    if (!unitData) {
      throw new Error(`Unit with ID ${unitID} not found in aggregate unit data`)
    }
    return (
      <UnitSelectionDisplay
        aggUnitData={unitData}
        site={site}
        isCalculatingRL={isCalculatingRL}
        selectedYear={selectedYear}
        useAssetLifecycle={useAssetLifecycle}
      />
    )
  }
}
